import { render, staticRenderFns } from "./StatisticsCardRadialBarChart.vue?vue&type=template&id=172563ee&"
import script from "./StatisticsCardRadialBarChart.vue?vue&type=script&lang=js&"
export * from "./StatisticsCardRadialBarChart.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCardRadialBarChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports